module.exports = __webpack_public_path__ + "static/media/0322_IMG_LE_SOL_CARRELAGE_EXISTANT.9bf93edc.webp";